// src/pages/Pedido/PixNoResumo.js
import React, { useEffect, useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { formatCurrency } from '../../utils/numberUtils';

const PixNoResumo = ({ pedido, onRetry }) => {
  const [mensagemCopia, setMensagemCopia] = useState('');
  const [mostrarQr, setMostrarQr] = useState(false);

  useEffect(() => {
    setMensagemCopia('');
    setMostrarQr(false);
  }, [pedido?.pixCopiaCola]);

  if (!pedido?.pixPendente) return null;

  const copiar = async () => {
    try {
      await navigator.clipboard.writeText(pedido.pixCopiaCola);
      setMensagemCopia('Código Pix copiado.');
    } catch (error) {
      setMensagemCopia('Não foi possível copiar. Selecione o código abaixo para copiar manualmente.');
    }
  };

  return (
    <section className="resumo-pix" aria-label="Pagamento via Pix">
      <h4>Pagamento via Pix</h4>
      <p className="resumo-pix-orientacao">Se quiser, você pode pagar agora por aqui.</p>
      <p className="resumo-pix-valor">Valor: <strong>{formatCurrency(pedido.valorTotal)}</strong></p>
      {pedido.pixCopiaCola ? (
        <>
          <button className="resumo-pix-copiar" type="button" onClick={copiar}>Copiar código Pix</button>
          {mensagemCopia && <p role="status">{mensagemCopia}</p>}
          <textarea
            className="resumo-pix-codigo"
            aria-label="Código Pix copia e cola"
            value={pedido.pixCopiaCola}
            readOnly
            rows={2}
            onFocus={event => event.target.select()}
          />
          <button
            className="resumo-pix-alternar-qr"
            type="button"
            aria-controls="resumo-pix-qr"
            aria-expanded={mostrarQr}
            onClick={() => setMostrarQr(aberto => !aberto)}
          >
            {mostrarQr ? 'Ocultar QR Code' : 'Mostrar QR Code'}
          </button>
          <div id="resumo-pix-qr" className={`resumo-pix-qr ${mostrarQr ? 'resumo-pix-qr-aberto' : ''}`}>
            <QRCodeCanvas value={pedido.pixCopiaCola} size={192} />
          </div>
        </>
      ) : (
        <div role="alert">
          <p>Não foi possível carregar o código Pix. Seu pedido já foi confirmado.</p>
          <button type="button" onClick={onRetry}>Tentar carregar Pix novamente</button>
        </div>
      )}
    </section>
  );
};

export default PixNoResumo;
